import { useAuth0 } from "@auth0/auth0-react";
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from "@mui/material/CircularProgress";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import InfoTooltip from 'components/InfoTooltip';
import { MyCheckbox } from 'components/MyCheckbox';
import AuthService from 'Lib/API/Auth/index';
import React, { useEffect, useState } from 'react';
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import AddNewTag from '../MemberDetails/AddNewTag';
import AddTagField from '../MemberDetails/AddTagField';
import { OrderFieldsTagging, OrderFieldsTaggingContent, OrderFieldsTaggingContentTitle, OrderFieldsTaggingFields, OrderFieldsTaggingItem, OrderFieldsTaggingLeft, OrderFieldsTaggingRight, OrderFieldsTaggingSeparator, OrderFieldsTaggingStatistics, OrderFieldsTaggingStatisticsBold, OrderFieldsTaggingStatisticsItem, OrderFieldsTaggingStatisticsLoading, OrderFieldsTaggingWrapper } from './Theme';
import { fontConfig } from "theme/fontConfig";

const selectControlStyles = {
  backgroundColor: "#f4f6f9",
  border: "1px solid #ebedf3",
  color: "#030303",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
  fontSize: "14px",

};
const colourStyles = {
  control: (styles, { isDisabled }) => ({
    ...styles,
    ...selectControlStyles,
    opacity: isDisabled ? 0.7 : 1,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
    fontSize: "14px",
    color: "#030303",
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "rgba(48, 90, 230, 0.2)",
    borderRadius: "33px",
    fontFamily: fontConfig.MembersSelectMultiValueFont.family,
    display: "flex",
    padding: "0 11px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    color: "#2555ef",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#2555ef",
    fontSize: "14px",
    padding: "0",
    paddingLeft: "0",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    padding: "0",
  }),
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};

const OrderFieldsBulkTagging = ({
  addAccountTags,
  setAddAccountTags,
  removeAccountTags,
  setRemoveAccountTags,
  addContactTags,
  setAddContactTags,
  removeContactTags,
  setRemoveContactTags,
  bulkCheckBoxes,
  setBulkCheckBoxes,
  statistics,
  showStatistics,
  getStatisticsLoading
}) => {
  const { getAccessTokenSilently } = useAuth0();

  const [openTag, setOpenTag] = useState(false);
  const [activeAddTag, setActiveAddTag] = useState("");

  const [accountTags, setAccountTags] = useState([]);
  const [contactTags, setContactTags] = useState([]);
  const [accountTagsLoading, setAccountTagsLoading] = useState(false);
  const [contactTagsLoading, setContactTagsLoading] = useState(false);



  const getAccountTagsHandler = async () => {
    const token = await getAccessTokenSilently();
    setAccountTagsLoading(true);
    AuthService.getTags(
      'account',
      "",
      "",
      token
    )
      .then((res) => {
        const tags = res?.result;
        const filterTags = tags?.map((item) => {
          return {
            label: item?.title,
            value: item?._id,
          };
        });
        setAccountTags(filterTags);
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setAccountTagsLoading(false);
      });
  };
  const getContactTagsHandler = async () => {
    const token = await getAccessTokenSilently();
    setContactTagsLoading(true);
    AuthService.getTags(
      'contact',
      "",
      "",
      token
    )
      .then((res) => {
        const tags = res?.result;
        const filterTags = tags?.map((item) => {
          return {
            label: item?.title,
            value: item?._id,
          };
        });
        setContactTags(filterTags);
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setContactTagsLoading(false);
      });
  };



  useEffect(() => {
    getAccountTagsHandler();
    getContactTagsHandler();
  }, []);

  const handleAddAccountTags = (tag) => {
    setAddAccountTags([...addAccountTags, tag]);
  };

  const handleRemoveAccountTags = (tag) => {
    const filteredTags = addAccountTags.filter((item) => item !== tag);
    setAddAccountTags(filteredTags);
  }


  const handleAddContactTags = (tag) => {
    setAddContactTags([...addContactTags, tag]);
  }

  const handleRemoveContactTags = (tag) => {
    const filteredTags = addContactTags.filter((item) => item !== tag);
    setAddContactTags(filteredTags);
  }



  const checkEnableStatistics = (type) => {
    if (type === "account") {
      return ((bulkCheckBoxes.addTagsAccounts && addAccountTags.length > 0) || (bulkCheckBoxes.removeAddTagsAccounts && removeAccountTags.length > 0));
    } else {
      return ((bulkCheckBoxes.addTagsContacts && addContactTags.length > 0) || (bulkCheckBoxes.removeAddTagsContacts && removeContactTags.length > 0));
    }
  }

  return (
    <OrderFieldsTagging>
      <OrderFieldsTaggingWrapper>
        <OrderFieldsTaggingContent>
          <OrderFieldsTaggingLeft>
            <OrderFieldsTaggingContentTitle style={{ display: 'flex', alignItems: 'center' }}>
              Bulk tagging
              <InfoTooltip text="Add or remove tags for every account/contact that matches this segment's filter — this applies to all matching members, not just a selection." style={{ marginLeft: '6px' }} />
            </OrderFieldsTaggingContentTitle>
            <OrderFieldsTaggingFields>
              <OrderFieldsTaggingItem>
                <MyCheckbox
                  handlechange={(e) =>
                    setBulkCheckBoxes({
                      ...bulkCheckBoxes,
                      addTagsAccounts: e.target.checked,
                    })
                  }
                  checked={bulkCheckBoxes.addTagsAccounts}
                  name={`add-tags-accounts`}
                  title="Add tags to accounts"
                />
                <AddTagField
                  tags={addAccountTags}
                  removeTagHandler={handleRemoveAccountTags}
                  fieldClickHandler={() => {
                    setOpenTag(true);
                    setActiveAddTag("account");
                  }}
                  disabled={!bulkCheckBoxes.addTagsAccounts}
                />
              </OrderFieldsTaggingItem>
              <OrderFieldsTaggingItem>
                <MyCheckbox
                  handlechange={(e) =>
                    setBulkCheckBoxes({
                      ...bulkCheckBoxes,
                      removeAddTagsAccounts: e.target.checked,
                    })
                  }
                  checked={bulkCheckBoxes.removeAddTagsAccounts}
                  name={`remove-add-tags-accounts`}
                  title="Remove tags from accounts"
                />
                <orderFieldsTaggingItemWrapper>
                  <Select
                    {...{
                      name: `accountTags`,
                      mandatory: false,
                      checkValidation: false,
                    }}
                    classNamePrefix="react-select"
                    options={accountTags}
                    valueKey="id"
                    labelKey="title"
                    isMulti
                    isLoading={accountTagsLoading}
                    styles={colourStyles}
                    onChange={(value) => {
                      setRemoveAccountTags(value);
                    }}
                    value={removeAccountTags}
                    components={{ DropdownIndicator }}
                    isDisabled={!bulkCheckBoxes.removeAddTagsAccounts}
                  />
                </orderFieldsTaggingItemWrapper>
              </OrderFieldsTaggingItem>
              <OrderFieldsTaggingItem>
                <MyCheckbox
                  handlechange={(e) =>
                    setBulkCheckBoxes({
                      ...bulkCheckBoxes,
                      addTagsContacts: e.target.checked,
                    })
                  }
                  checked={bulkCheckBoxes.addTagsContacts}
                  name={`add-tags-contacts`}
                  title="Add tags to people"
                />
                <AddTagField
                  tags={addContactTags}
                  removeTagHandler={handleRemoveContactTags}
                  fieldClickHandler={() => {
                    setOpenTag(true);
                    setActiveAddTag("contact");
                  }}
                  disabled={!bulkCheckBoxes.addTagsContacts}
                />
              </OrderFieldsTaggingItem>
              <OrderFieldsTaggingItem>
                <MyCheckbox
                  handlechange={(e) =>
                    setBulkCheckBoxes({
                      ...bulkCheckBoxes,
                      removeAddTagsContacts: e.target.checked,
                    })
                  }
                  checked={bulkCheckBoxes.removeAddTagsContacts}
                  name={`remove-add-tags-contacts`}
                  title="Remove tags from people"
                />
                <Select
                  {...{
                    name: `contactTags`,
                    mandatory: false,
                    checkValidation: false,
                  }}
                  classNamePrefix="react-select"
                  options={contactTags}
                  valueKey="id"
                  labelKey="title"
                  isMulti
                  isLoading={contactTagsLoading}
                  styles={colourStyles}
                  onChange={(value) => {
                    setRemoveContactTags(value);
                  }}
                  value={removeContactTags}
                  components={{ DropdownIndicator }}
                  isDisabled={!bulkCheckBoxes.removeAddTagsContacts}
                />
              </OrderFieldsTaggingItem>
            </OrderFieldsTaggingFields>
          </OrderFieldsTaggingLeft>
          <OrderFieldsTaggingSeparator />
          <OrderFieldsTaggingRight>
            {getStatisticsLoading ? (
              <OrderFieldsTaggingStatisticsLoading>
                <CircularProgress
                  size={30}
                  style={{
                  }}
                />
              </OrderFieldsTaggingStatisticsLoading>
            ) : showStatistics && (
              <OrderFieldsTaggingStatistics>
                {checkEnableStatistics("account") && (
                <OrderFieldsTaggingStatisticsItem>
                  <OrderFieldsTaggingStatisticsBold>{statistics?.accounts || 0}</OrderFieldsTaggingStatisticsBold> Accounts will be updated
                </OrderFieldsTaggingStatisticsItem>
                )}
                {checkEnableStatistics("contact") && (
                <OrderFieldsTaggingStatisticsItem>
                  <OrderFieldsTaggingStatisticsBold>{statistics?.contacts || 0}</OrderFieldsTaggingStatisticsBold> People will be updated
                </OrderFieldsTaggingStatisticsItem>
                )}
              </OrderFieldsTaggingStatistics>
            )}
          </OrderFieldsTaggingRight>
        </OrderFieldsTaggingContent>
        <div className="tag_modal">
          <Dialog
            open={openTag}
            onClose={() => {
              setOpenTag(false);
              setActiveAddTag("");
            }}
            PaperProps={{
              style: {
                border: "1px solid #000000",
                background: "#f5f5f5",
              },
            }}
          >
            <AddNewTag
              setOpenTag={setOpenTag}
              openTag={openTag}
              addTagHandler={(tag) => {
                if (activeAddTag === "account") {
                  handleAddAccountTags(tag);
                } else {
                  handleAddContactTags(tag);
                }
              }}
              deleteTagHandler={(tag) => {
                if (activeAddTag === "account") {
                  handleRemoveAccountTags(tag);
                } else {
                  handleRemoveContactTags(tag);
                }
              }}
              selectedUserTag={activeAddTag === "account" ? addAccountTags : addContactTags}
              type={activeAddTag}
            />
          </Dialog>
        </div>
      </OrderFieldsTaggingWrapper>
    </OrderFieldsTagging>
  )
}

export default OrderFieldsBulkTagging